import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from 'react-i18next'

interface DeleteAnswerDialogProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    answerTitle: string
}

export function DeleteAnswerDialog({
    isOpen,
    onClose,
    onConfirm,
    answerTitle
}: DeleteAnswerDialogProps) {
    const { t } = useTranslation()
    return (
        <AlertDialog open={isOpen} onOpenChange={onClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('knowledgePage.deleteAnswer')}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('knowledgePage.deleteAnswerConfirm', { title: answerTitle })}
                        <br />
                        {t('knowledgePage.deleteAnswerWarning')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>
                        {t('global.button.cancel')}
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onConfirm}
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                    >
                        {t('global.button.delete')}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}